module.exports = __webpack_public_path__ + "static/media/map.33d4ccbd.png";